module.exports = __webpack_public_path__ + "static/media/header.5c79cf11.svg";